<template>
  <div id="News">
    <Table :show-header="false" ref="selection" @on-row-click="handleCurrentRow" :columns="columns" :data="list" no-data-text="暂无筛选结果">
      <template #cover="{ row }">
        <img :src="row.cover" style="width: 120px;height: 60px;margin: 5px;">
      </template>
    </Table>
  </div>
</template>

<script>
import {getNewList} from "@/request/web/news";

export default {
  name: "News",
  // 注册组件
  components: {},
  // 属性
  props: {},
  // 页面数据
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 8
      },
      columns: [
        {
          title: '新闻封面',
          width: 120,
          slot: 'cover'
        },
        {
          title: '新闻标题',
          width: 180,
          key: 'new_title'
        },
        {
          title: '作者',
          width: 100,
          key: 'author'
        },
        {
          title: '新闻简介',
          key: 'brief'
        },
        {
          title: '阅读次数',
          width: 100,
          align: 'center',
          key: 'read_count'
        }
      ],
      list: []
    }
  },
  created() {
    this.onGetNewList()
  },
  methods: {
    // 获取会员单位列表
    onGetNewList() {
      getNewList({
        ...this.page,
        filter: {}
      }).then(res=> {
        this.list = res.data.data.list
      })
    },
    handleCurrentRow(news) {
      this.$router.push(`/news/detail/${news['new_id']}`)
    }
  }
}
</script>

<style scoped>
table {
  text-align: left;
  width: 100%;
  border-collapse:collapse;
}

table thead {
  color: #fff;
}

table thead tr {
  color: #fff;
  height: 25px;
  cursor: pointer;
}

table thead tr th {
  height: 25px;
}

table tbody tr {
  cursor: pointer;
}

table tbody tr:hover {
  cursor: pointer;
}

table tbody tr td{
  padding: 5px 0;
}

table body tr td p{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>
